module.exports = __webpack_public_path__ + "static/media/empty-state-no-data-light-gray@2x.75b8f5bb.png";